import { useEffect, useRef, useState } from "react";
import { SxProps, Theme, Tooltip, Typography } from "@mui/material";
import theme from "assets/styles/themes";

const colorConfig = {
    primary: {
        color: theme.palette.text.primary,
        border: `1px solid ${theme.palette.neutrals.dark}`,
    },
    secondary: {
        color: theme.palette.common.white,
        border: `1px solid ${theme.palette.common.white}`,
    },
};

const TagName = ({
    children,
    color = "primary",
    isTruncated = false,
    sx,
}: {
    children: string;
    color?: "primary" | "secondary";
    isTruncated?: boolean;
    sx?: SxProps<Theme>;
}) => {
    const ref = useRef<HTMLDivElement>(null);
    const [isOverflow, setIsOverflow] = useState(false);

    useEffect(() => {
        if (isTruncated && ref.current) {
            const { scrollWidth, clientWidth } = ref.current;
            setIsOverflow(scrollWidth > clientWidth);
        }
    }, [isTruncated, isOverflow]);

    const tagContent = (
        <Typography
            ref={ref}
            sx={{
                fontSize: 16,
                display: "inline-block",
                padding: theme.spacing(0.25, 1),
                borderRadius: theme.spacing(1),
                ...colorConfig[color],
                ...(isTruncated && {
                    maxWidth: 200,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "pre",
                    cursor: "default",
                }),
                ...sx,
            }}
        >
            {children}
        </Typography>
    );

    return isTruncated && isOverflow ? (
        <Tooltip arrow placement="bottom-start" title={children}>
            {tagContent}
        </Tooltip>
    ) : (
        tagContent
    );
};

export default TagName;
